module.exports = __webpack_public_path__ + "img/92072.17b3585d.svg";